// Platform names shown in the app — MSC discloses only the processor (TSYS, Fiserv, Global/EPX, Cygma, Square)
export const PROCESSOR_DISPLAY_MAP = {
  'tsys-msc': 'TSYS',
  'north': 'Global/EPX',
  'north_epx': 'Global/EPX',
  'epx': 'Global/EPX',
  'fiservcopilot': 'Fiserv',
  'maverick': 'TSYS',
  'maverick payments': 'TSYS / Fiserv (MSC)',
  'north (payments hub)': 'Global/EPX',
  'fiserv': 'Fiserv',
  'cygma': 'Cygma',
  'square': 'Square',
  'msc_mbi_tsys': 'TSYS',
  'msc_mbi_fiserv': 'Fiserv',
  'msc_fiserv_copilot': 'Fiserv',
  'msc_epx': 'Global/EPX',
  'msc_cygma_epi': 'Cygma',
};

export const displayProcessor = (name) => (name == null ? name : PROCESSOR_DISPLAY_MAP[String(name).toLowerCase()] || name);

// One option per visible name (the first stored value wins), so lists never show "TSYS" twice.
export const uniqueProcessors = (list) => list.filter((p, i) => list.findIndex((x) => displayProcessor(x) === displayProcessor(p)) === i);
